import React, { Component } from "react";
import ApexCharts from 'apexcharts'
export default class TopOffenderNew extends Component {
	constructor(props) {
		super(props);
		this.state = { chart: null }
	}

	componentDidMount = () => {
		this.load();
	}

	load = () => {
		let colors = ['#1967D2', '#1F85E4', '#57A1EF', '#84BBF9', '#B8D6FF'];
		let options = {
			series: [{
				name: 'Offenders',
				data: this.props.topOffender['count']? this.props.topOffender['count']: []
			}],
			colors: [
				function ({ value, seriesIndex, dataPointIndex, w }) {
					return colors[dataPointIndex]
				}
			],
			chart: {
				type: 'bar',
				height: 275,
				width:550,
				toolbar: {
					show: false
				}
			},
			plotOptions: {
				bar: {
					horizontal: true,
					columnWidth: '20%',
					barHeight: '40%'
				},
			},
			tooltip: {
				enabled: false
			},
			dataLabels: {
				enabled: false
			},
			legend: {
				show: true,
			},
			stroke: {
				show: true,
				width: 2,
				colors: ['transparent']
			},
			fill: {
				opacity: 1
			},
			grid: {
				show: true,
			},
			xaxis: {
				labels: {
					rotate: 0,
			  	},
				categories: this.props.topOffender['name']? this.props.topOffender['name']: []
			},

		}
		var chart = new ApexCharts(document.querySelector("#top"), options);
		chart.render();
		this.setState({ chart: chart });
	}

	componentDidUpdate = (prevProps) => {
		if(this.props.topOffender !== prevProps.topOffender){
			if(this.state.chart) this.state.chart.destroy();
			this.load();
		}
	}

	render() {
		return (
			<div id="top"></div>
		);
	}
}